module.exports = __webpack_public_path__ + "img/house.f586aa66.svg";